define('home/models/SettingsAccount',[
    'underscore',

    'core/config',

    'home/collections/SettingsSocialAccountCollection',
    'home/models/common/BaseSettings',
    'core/UniqueModel',
], function (
    _,

    config,

    SettingsSocialAccountCollection,
    BaseSettings,
    UniqueModel
) {
    'use strict';

    var SettingsAccount = BaseSettings.extend({
        url: config.urls.apiSettings + 'account/',

        initialize: function () {
            this.socialAccounts = new SettingsSocialAccountCollection();
        },

        parse: function (response) {
            var socialAccountModels = _.map(response.social_accounts, function (socialAccount, accountType) {
                socialAccount.id = accountType;
                return socialAccount;
            });

            // Add all models with a reset so that only one 'reset' event is triggered on the collection
            this.socialAccounts.reset(socialAccountModels);

            delete response.social_accounts;
            return BaseSettings.prototype.parse.call(this, response);
        },

        toJSON: function () {
            return {
                'username': this.get('username'),
                'email': this.get('email'),
                'password': this.get('password'),
                'old_password': this.get('old_password'),
                'email_verified': this.get('email_verified'),
            };
        },
    });

    UniqueModel.addType('SettingsAccount', SettingsAccount);

    return SettingsAccount;
});

